import { IGif, INiche, IUser } from "services/types";
import { UserInfo } from "./UserInfo";
import { TagList } from "components/tags";
import { BaseButton } from "components/buttons/BaseButton";
import { memo, useCallback } from "react";
import LiveButton from "components/ads/LiveButton";
import { clsx } from "clsx";

const MetaInfo = (props: {
  gif: IGif;
  user: IUser | undefined;
  niches: INiche[];
  embedded: boolean;
  rel?: string;
}) => {
  const tags = useCallback(() => {
    return props.gif.tags.map((tag: string) => ({
      name: tag,
      count: 0,
    }));
  }, [props.gif.tags]);

  return (
    <div className={clsx("author-wrap", props.gif.cta && "is-boosted")}>
      {props.user && <UserInfo
        gif={props.gif}
        user={props.user}
        external={props.embedded}
        rel={props.rel}
      />}
      {!props.gif.cta && !props.embedded && (props.gif.tags.length + props.niches.length) > 0 && (
        <TagList niches={props.niches} tags={tags()} />
      )}
      {props.gif.cta && (
        <div className="boosted-btn">
          <BaseButton
            onClick={() => window.open(props.gif.cta?.link, "_blank")}
          >{props.gif.cta.text}</BaseButton>
        </div>
      )}
      <div className="live-button">
        <LiveButton />
      </div>
    </div>
  );
};

export const MetaInfoMemo = memo(MetaInfo);
